import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MdBlock, MdInline } from '@domain/ai-assistant/markdown.models';
import { parseMarkdown } from '@domain/ai-assistant/markdown.parser';

@Component({
  selector: 'app-markdown',
  imports: [NgTemplateOutlet],
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class MarkdownComponent {
  public source = input<string>('');

  public readonly blocks = computed(() => parseMarkdown(this.source()));

  public trackBlock(_index: number, block: MdBlock): string {
    return `${block.kind}-${_index}`;
  }

  public trackInline(_index: number, inline: MdInline): string {
    return `${inline.kind}-${_index}`;
  }
}
